import React from 'react';
import S from './CookieDeclaration.styles';
const CookieDeclaration = ({ domainGroupId }) => {
    if (!domainGroupId) {
        console.error('CookieDeclaration: "domainGroupId" was not provided.');
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement("script", { id: "CookieDeclaration", src: `https://consent.cookiebot.com/${domainGroupId}/cd.js`, type: "text/javascript", async: true }))));
};
export default CookieDeclaration;
